var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListadoControlDeAccesos',{attrs:{"fields":_vm.fields,"controlAcessos":_vm.controlAcessosAbonos,"filtros":_vm.filtros,"loading":_vm.loading,"metodos_pagos":_vm.metodos_pago_abonados},on:{"getcontrolAcessos":_vm.getControlAcessosAbonos}})
}
var staticRenderFns = []

export { render, staticRenderFns }